import styled from 'styled-components'
import { FadeInFrame } from '../../styles/keyframes'

export const StyledFooter = styled.footer`
width: 100%;
display: flex;
justify-content: center;
animation: ${FadeInFrame} 1s linear;
position: relative;
padding: 4rem;

@media (orientation:portrait) {
    flex-direction: column;
    align-items: center;
    display: flex;
    margin-top: 1rem;
}
`
